<template>
  <div class="d-flex justify-content-between">
    <input
      type="text"
      :value="maskedValue"
      :ref="'inputRefABN'"
      class="w-100"
      placeholder="ABN"
      @input="handleInput($event)"
    />
    <el-button
      plain
      class="btn-secondary px-2 py-1 h-100"
      @click="getABNData"
      :loading="loading"
    >
      <i class="fa fa-search font-14"></i>
    </el-button>
  </div>
</template>

<script>
import ABNFormat from "../mixins/ABNFormat";
import AbnLookup from "../frontend/modelsPortal/common/AbnLookup";
export default {
  mixins: [ABNFormat],
  name: "InputAbn",
  model: {
    prop: "hiddenValue",
    event: "blur",
  },
  props: {
    hiddenValue: {
      type: [String, Number],
    },
  },
  data() {
    return {
      loading: false,
      found: false,
      visible: false,
    };
  },
  computed: {
    maskedValue(event) {
      const vm = this;

      if (!vm.hiddenValue) {
        return "";
      }
      // Convert number value to string
      let maskedVal = String(vm.hiddenValue).slice(0, 11);

      return maskedVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
  methods: {
    getABNData() {
      let abn = this.hiddenValue;
      this.loading = true;
      let abnData = null;
      if (abn) {
        let result = this.validateABN(abn);
        if (result) {
          new AbnLookup()
            .params({ abn: abn })
            .get()
            .then((res) => {
              if (res.length == 1) {
                abnData = res[0];
                this.$emit("data", abnData);
              } else {
                this.$message.error("ABN not found");
              }
            })
            .catch((err) => {
              this.$message.error("Looks like something went wrong.");
            })
            .finally((_) => {
              this.loading = false;
            });
          return;
        } else {
          this.$emit("data", abnData);
        }
      } else {
        this.$emit("data", abnData);
      }
      this.loading = false;
      this.$message.error("Invalid ABN");
    },
    handleInput(event) {
      const vm = this;

      // Now unmask the value by applying reverse logic
      let unMaskedVal = event.target.value
        .replace(/\s/g, "")
        .replace(/[^\d,]/g, "")
        .slice(0, 11);

      // Emit the blur event so it automatically sets the hiddenValue
      vm.$emit("blur", unMaskedVal);

      this.$forceUpdate();
    },
  },
};
</script>
